// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "./assets/chunks/BO-13598-rc.202609090750." + {"259":"e0bf359b05e11bacde7b","267":"33fa2c6a5a036237f86e","429":"009eacb0660c0f2eb2f5","816":"20767e06259a39acd325"}[chunkId] + ".js";
};